import React from "react";
import clsx from "clsx";

import { activeLearningClassDataPath } from "../../../teacherStore";
import { ReactComponent as IconArrowAccordion } from "../../../assets/images/ActiveLearning/icon_arrow_accordion.svg";

import styles from "./StudentAnswer.module.scss";

type StudentAnswerProps = {
  isAnswered: boolean;
  isAccordion?: boolean;
  no: string;
  name: string;
  classId?: number;
  studentId?: number;
};

export const StudentAnswer: React.FC<StudentAnswerProps> = ({
  isAnswered,
  isAccordion,
  no,
  name,
  classId,
  studentId,
  children,
}) => {
  return (
    <details
      className={clsx(
        styles.wrapper,
        isAnswered && styles.isAnswered,
        isAccordion && styles.isAccordion,
      )}
      open={!isAccordion && true}
    >
      <summary
        className={clsx(
          styles.label,
          (!isAnswered || !isAccordion) && styles.isDisabled,
        )}
      >
        <div className={styles.student}>
          <span className={styles.no}>{no}</span>
          <span className={styles.name}>{name}</span>
        </div>
        {isAnswered && isAccordion && (
          <IconArrowAccordion className={styles.arrow} />
        )}
      </summary>
      {isAnswered && (
        <>
          <div className={styles.contents}>{children}</div>
          <a
            className={styles.link}
            href={`${activeLearningClassDataPath}/${classId}/student/${studentId}/response`}
            target="_blank"
            rel="noopener noreferrer"
          >
            回答一覧を見る
          </a>
        </>
      )}
    </details>
  );
};

export default StudentAnswer;
